// extracted by mini-css-extract-plugin
export default {"container":"Nats_container__csjFY","containerInner":"Nats_containerInner__UnBKj","header":"Nats_header__8h5W9"};